// =====================================
//
//   home banner
//   Author: Gray
//   createtime: 2016 / 09 / 05
//   updatetime: 2016 / 09 / 05
//
// =====================================

window.InifECMobileApp.directive('homeBanner', ['$rootScope', '$compile', '$timeout', function($rootScope, $compile, $timeout) {

	var _dir = {};

	var link = function(scope, element, attrs) {

    	var bindCarousel = function() {
            var $owl = $(element);
            $owl.owlCarousel({
                loop:true,
                autoplay:true,
                autoplayTimeout:7000,
                autoplayHoverPause:true,
                items : 1,
                dots: true,
                dotsContainer : ".dot-content",
                dotData : true,
                autoplayHoverPause: true,
                lazyLoad: true,
            });
    	}

        var createHtml = function() {

            for(var i = 0; i < scope.homeBanner.length; i++) {
                var image = getIndexADRotionImage(scope.homeBanner[i]);

                image = image.replace('https://', '//');
                image = image.replace('http://', '//');
                image = image.replace('/large', '/medium');
                if(location.protocol.startsWith("file")){
                    image = 'http://' + image;
                }
                
                var linkurl = scope.homeBanner[i].linkurl;

                // var html = '<a class="image" style="background-image: url(' + image + ')"'
                var html = '<a class="image owl-lazy" data-src="' + image + '"'

                if(linkurl && linkurl != '') {
                    html += ' href="' + linkurl + '"';
                }

                if(scope.homeBanner[i].isLinkTargetSelf) {
                    html += ' ></a>';
                } else {
                    html += ' target="_blank"></a>';
                }

                var newhtml = $compile(html)(scope);

                $(element).append(newhtml);
            }

            $timeout(function() {
                bindCarousel();
            }, 300);
        }

        var getIndexADRotionImage = function(adblock) {
            
            if(!adblock || !adblock.coverUrl) {
                return "about:blank";
            }

            return adblock.coverUrl;
        }

        var init = function() {
            
            if(Array.isArray(scope.homeBanner) && scope.homeBanner.length > 0){
                createHtml();
            }
        }

        scope.$watchCollection("homeBanner", init);

    	//==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        // init();

	};

	_dir.restrict = 'A';
	_dir.scope = {
        homeBanner: "="
    };
	_dir.link = link;

	return _dir;

}]);
